import React, { useState, useEffect } from 'react';
import { Icon } from '../Icon/Icon';
import GlobalSearch from 'pages/GlobalSearch/GlobalSearch';
import { Badge } from 'components';
import { useSelector } from 'react-redux';

export const SearchLauncher = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { notificationCount } = useSelector((state) => state.global);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setIsOpen((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <>
      <button
        type='button'
        className='user-search-floating-button'
        onClick={openModal}
        aria-label='Search users by name'
      >
        <Icon name='Search_Magnifying_Glass' size='md' />
        <Badge count={notificationCount} />
      </button>
      <GlobalSearch isOpen={isOpen} onClose={closeModal} />
    </>
  );
};
